import { useState } from 'react';
import { addToCart } from '../../utils/functions';


const Grid = ({ products, attributes }) => {
    const { columns } = attributes;
    const { desktop = 3, tablet = 2, mobile = 1 } = columns;
    const [loadingStates, setLoadingStates] = useState({});



    const setProductLoading = (productId, isLoading) => {
        setLoadingStates(prevState => ({
            ...prevState,
            [productId]: isLoading
        }));
    };

    return (
        <>
            <div className={`grid columns-${desktop} columns-tablet-${tablet} columns-mobile-${mobile}`}>
                {products?.map((product, index) => {
                    const { id, thumbnail, name, regular_price, price, sale_price, currency, product_type, link } = product;
                    console.log(link);

                    const isLoading = loadingStates[id] || false;

                    return (
                        <div className='single_item' key={index}>
                            <a className="img" href={link}>
                                <img src={thumbnail.src} alt="" />
                            </a>
                            <a className="name" href={link}>
                                <h2>{name}</h2>
                            </a>

                            <div className="price_area">
                                {sale_price ? (
                                    <div className="sale_price">
                                        {sale_price} {currency}
                                    </div>
                                ) : (
                                    <div className='discount_price'>
                                        <div className="regular_price">
                                            {regular_price && <>{regular_price} {currency} </>}
                                        </div>
                                        <div className="price">
                                            {price} {currency}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="cart_btn">
                                {product_type === "simple" ? (
                                    <button onClick={() => addToCart(id, 1, setProductLoading)}>
                                        {isLoading ? 'Loading...' : 'Add to Cart'}
                                    </button>
                                ) : (
                                    <a href={link}>View Products</a>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default Grid;
